import React from 'react';
import './styles.css';
import BETO from '../../img/beto.jpg';
import LOGO from '../../img/foco90.svg';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';

const URL= WS.paginas.politica;

class PoliticaPrivacidade extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      loaded: false,
      page: ''
    }
  }

  componentDidMount(){
    const self = this;

    Requisitions({
      url: URL,
      data:{ htmldb: 1 },
      sucess:function(data){
        var msg;
        self.setState({
          page: data,
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }


  render() {
    const view = this.state.page;

    return (
      <div className="login-wrapper" >
        <div className="">
          <div className="">
              <div className="">
                <div className="box-login">
                  <div className="box-login--inner">
                    <div className="box-login-logo"><img src={LOGO} /></div>
                    <p className='title-politica'>{this.state.strings.politicaPrivacidade}</p>
                    <div dangerouslySetInnerHTML={{__html: view}}>
                    </div>
                  </div>
                </div>
              </div>

          </div>
        </div>
      </div>
    );
  }
}

export default PoliticaPrivacidade;



// WEBPACK FOOTER //
// ./src/classes/politica/PoliticaPrivacidade.js